import React from "react";

interface Props {
  isActive: boolean;
}

export default function MyCoverIcon({ isActive }: Props) {
  return (
    <svg
      width="18"
      height="22"
      viewBox="0 0 18 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.49912 5C4.49912 3.80653 4.97323 2.66193 5.81714 1.81802C6.66105 0.974106 7.80565 0.5 8.99912 0.5C10.1926 0.5 11.3372 0.974106 12.1811 1.81802C13.025 2.66193 13.4991 3.80653 13.4991 5C13.4991 6.19347 13.025 7.33807 12.1811 8.18198C11.3372 9.02589 10.1926 9.5 8.99912 9.5C7.80565 9.5 6.66105 9.02589 5.81714 8.18198C4.97323 7.33807 4.49912 6.19347 4.49912 5ZM0.750119 19.105C0.78384 16.9395 1.66776 14.8741 3.21108 13.3546C4.7544 11.8351 6.83333 10.9834 8.99912 10.9834C11.1649 10.9834 13.2438 11.8351 14.7872 13.3546C16.3305 14.8741 17.2144 16.9395 17.2481 19.105C17.2507 19.2508 17.2108 19.3942 17.1332 19.5176C17.0555 19.641 16.9436 19.7392 16.8111 19.8C14.3603 20.9237 11.6953 21.5037 8.99912 21.5C6.21312 21.5 3.56612 20.892 1.18712 19.8C1.05461 19.7392 0.942695 19.641 0.865082 19.5176C0.787468 19.3942 0.747518 19.2508 0.750119 19.105Z"
        fill={isActive ? "#5E9918" : "#B3B3B3"}
      />
    </svg>
  );
}
